import React from 'react';
import { Badge, IconButton } from '@material-ui/core'
import {
  PeopleRounded,
} from '@material-ui/icons'

const onButtonClick = props => () => props.showModal({ type: 'waitingList' })

export const WaitingListIcon = props => (
  <IconButton
    color='inherit'
    onClick={onButtonClick(props)}
    className={props.classes.container}
  >
    <Badge
      color='secondary'
      invisible={!props.waitingPassengersQty}
      badgeContent={props.waitingPassengersQty}
    >
      <PeopleRounded />
    </Badge>
  </IconButton>
);



// WEBPACK FOOTER //
// ./src/components/WaitingListIcon/WaitingListIcon.js